import Api from "../../../services/api";

export function getCboEmployee(params, cb) {
    return () => {
        Api.get('/w17f1202/load-cbo-employee', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function getCboGroupSales(cb) {
    return () => {
        Api.get('/w17f1202/load-cbo-group-sales')
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadForm(params, cb) {
    return () => {
        Api.put('/w17f1202/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}
